import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { StudyBundleCourseStatusType } from '../../../shared/types/StudyBundleCourseStatusType';
import { TileStatusType } from '../../../shared/types/tile-status-type';

@Component({
  selector: 'lp2-tile-progress-label',
  templateUrl: './tile-progress-label.component.html',
  styleUrls: ['./tile-progress-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileProgressLabelComponent {
  @Input() status: TileStatusType | StudyBundleCourseStatusType;
}



// WEBPACK FOOTER //
// ./ts/app/home/generic-tile/tile-progress-label/tile-progress-label.component.ts